const FULL_TURN_DEG = 360;
const ANGLE_DECIMALS = 3;
const SWEEP_PROGRESS = 'var(--motion-sweep-progress)';

const degrees = (angle: number): string =>
  `${Number(angle.toFixed(ANGLE_DECIMALS))}deg`;

export const donutSweepMask = (
  values: number[],
  centerY: number,
): string | null => {
  const weights = values.map(value => Math.max(Number(value) || 0, 0));
  const total = weights.reduce((sum, weight) => sum + weight, 0);
  if (!total) {
    return null;
  }
  let angle = 0;
  const segments = weights.flatMap(weight => {
    const span = (weight / total) * FULL_TURN_DEG;
    const start = degrees(angle);
    angle += span;
    return weight
      ? [
          `black ${start} calc(${start} + ${degrees(span)} * ${SWEEP_PROGRESS}), transparent 0 ${degrees(angle)}`,
        ]
      : [];
  });
  return `conic-gradient(at 50% ${centerY}px, ${segments.join(', ')})`;
};
